export default __webpack_public_path__ + "static/media/509.448633bf.gif";